import React, { useState, useEffect, useRef } from "react";
import "./Separation.css";
import config from "../../config";
import Header from "../../components/common/Header";
import { IoIosArrowBack } from "react-icons/io";
import { FaUser } from "react-icons/fa6";
import TerminationPopup from "./TerminationPopup";
import ExitPopup from "./ExitPopup";

const SeparationDetail = ({ employee, onBack, setActivePage }) => {
  const [employeeDetail, setEmployeeDetail] = useState(null);
  const [loading, setLoading] = useState(true);
  const [assets, setAssets] = useState([]);
  const [assetInput, setAssetInput] = useState("");
  const [salaryComponents, setSalaryComponents] = useState([]);
  const [showTerminateModal, setShowTerminateModal] = useState(false);
  const [showExitModal, setShowExitModal] = useState(false);
  const assetInputRef = useRef(null);

  useEffect(() => {
    if (!employee?.employeeId) return;
    fetchDetail(employee.employeeId);
  }, [employee]);

  const fetchDetail = async (id) => {
    setLoading(true);
    try {
      const token = localStorage.getItem("Authorization");
      const res = await fetch(
        `${config.API_BASE_URL}${config.GET_EMPLOYEE_DETAIL_ENDPOINT}${id}`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json",
          },
        }
      );
      const data = await res.json();
      const emp = data.body || data.data || data;
      setEmployeeDetail(emp);

      // Pre-populate assets if available
      if (emp.assets && Array.isArray(emp.assets)) {
        setAssets(emp.assets);
      }

      // Pre-populate salary components if available
      if (emp.salaryComponents && Array.isArray(emp.salaryComponents)) {
        setSalaryComponents(emp.salaryComponents);
      } else if (emp.components && Array.isArray(emp.components)) {
        setSalaryComponents(emp.components);
      }
    } catch (err) {
      console.error("Failed to fetch employee detail:", err);
    } finally {
      setLoading(false);
    }
  };

  const handleAddAsset = (e) => {
    if (e.key === "Enter" && assetInput.trim()) {
      e.preventDefault();
      setAssets((prev) => [...prev, assetInput.trim()]);
      setAssetInput("");
    }
  };

  const handleRemoveAsset = (index) => {
    setAssets((prev) => prev.filter((_, i) => i !== index));
  };

  const d = employeeDetail || {};

  return (
    <div className="sep-detail-wrapper">
      <Header
        title="Separation"
        subtitle="Employee Details"
        onProfileClick={() => setActivePage && setActivePage("Profile")}
      />

      <div className="sep-detail-content" style={{ margin: "0 20px 20px" }}>
        {/* Back Button */}
        <div style={{ padding: "16px 0 0" }}>
          <button className="sep-back-btn" onClick={onBack} title="Back to list">
            <IoIosArrowBack />
            <span style={{ fontSize: "14px", marginLeft: "4px" }}>Back</span>
          </button>
        </div>

        {loading ? (
          <div style={{ textAlign: "center", padding: "40px", color: "#999" }}>
            Loading employee details...
          </div>
        ) : (
          <>
            {/* Separation */}
            <div className="sep-form-section">
              <div className="sep-section-title">
                <FaUser />
                <span>Separation</span>
              </div>
              <div className="sep-form-grid">
                <div className="sep-input-group">
                  <label>Reason</label>
                  <input type="text" value={d.reason || ""} readOnly />
                </div>
                <div className="sep-input-group">
                  <label>Separation type</label>
                  <input type="text" value={d.terminateExitStatus || ""} readOnly />
                </div>
                <div className="sep-input-group">
                  <label>Initiated By</label>
                  <input type="text" value={d.terminatedBy || d.initiatedBy || ""} readOnly />
                </div>
                <div className="sep-input-group">
                  <label>Approved By</label>
                  <input type="text" value={d.approvedBy || ""} readOnly />
                </div>
                <div className="sep-input-group">
                  <label>Notice Period</label>
                  <input type="text" value={d.noticePeriod || ""} readOnly />
                </div>
              </div>
            </div>

            {/* Personal Information */}
            <div className="sep-form-section">
              <div className="sep-section-title">
                <FaUser />
                <span>Personal Information</span>
              </div>
              <div className="sep-form-grid">
                <div className="sep-input-group">
                  <label>Employee Name</label>
                  <input type="text" value={d.employeeName || ""} readOnly />
                </div>
                <div className="sep-input-group">
                  <label>Date of Birth</label>
                  <input type="text" value={d.dateOfBirth || ""} readOnly />
                </div>
                <div className="sep-input-group">
                  <label>Client Employee ID</label>
                  <input type="text" value={d.employeeCode || ""} readOnly />
                </div>
                <div className="sep-input-group">
                  <label>Phone Number</label>
                  <input type="text" value={d.phoneNumber || ""} readOnly />
                </div>
                <div className="sep-input-group">
                  <label>Email Address</label>
                  <input type="text" value={d.emailAddress || ""} readOnly />
                </div>
                <div className="sep-input-group">
                  <label>Gender</label>
                  <input type="text" value={d.gender || ""} readOnly />
                </div>
                <div className="sep-input-group">
                  <label>Aadhar Number</label>
                  <input type="text" value={d.aadharNumber || ""} readOnly />
                </div>
                <div className="sep-input-group">
                  <label>UAN Number</label>
                  <input type="text" value={d.uanNumber || ""} readOnly />
                </div>
                <div className="sep-input-group">
                  <label>Marital Status</label>
                  <input type="text" value={d.maritalStatus || ""} readOnly />
                </div>
              </div>
            </div>

            {/* Work Information */}
            <div className="sep-form-section">
              <div className="sep-section-title">
                <FaUser />
                <span>Work Information</span>
              </div>
              <div className="sep-form-grid">
                <div className="sep-input-group">
                  <label>Client</label>
                  <input type="text" value={d.clientName || ""} readOnly />
                </div>
                <div className="sep-input-group">
                  <label>Sub Vendor</label>
                  <input type="text" value={d.subVendorName || ""} readOnly />
                </div>
                <div className="sep-input-group">
                  <label>Job Role</label>
                  <input type="text" value={d.jobRole || ""} readOnly />
                </div>
                <div className="sep-input-group">
                  <label>Department</label>
                  <input type="text" value={d.department || ""} readOnly />
                </div>
                <div className="sep-input-group">
                  <label>Work Site</label>
                  <input type="text" value={d.workSite || ""} readOnly />
                </div>
                <div className="sep-input-group">
                  <label>Date of Joining</label>
                  <input type="text" value={d.dateOfJoin || ""} readOnly />
                </div>
                <div className="sep-input-group">
                  <label>Work Type</label>
                  <input type="text" value={d.workType || ""} readOnly />
                </div>
                <div className="sep-input-group">
                  <label>Shift Type</label>
                  <input type="text" value={d.shiftType || ""} readOnly />
                </div>
                <div className="sep-input-group">
                  <label>Contract Duration</label>
                  <input type="text" value={d.contractDuration || ""} readOnly />
                </div>
              </div>
            </div>

            {/* Address */}
            <div className="sep-form-section">
              <div className="sep-section-title">
                <FaUser />
                <span>Address</span>
              </div>
              <div className="sep-form-grid">
                <div className="sep-input-group">
                  <label>Address</label>
                  <input type="text" value={d.address || ""} readOnly />
                </div>
                <div className="sep-input-group">
                  <label>City</label>
                  <input type="text" value={d.city || ""} readOnly />
                </div>
                <div className="sep-input-group">
                  <label>District</label>
                  <input type="text" value={d.district || ""} readOnly />
                </div>
                <div className="sep-input-group">
                  <label>State</label>
                  <input type="text" value={d.state || ""} readOnly />
                </div>
                <div className="sep-input-group">
                  <label>Country</label>
                  <input type="text" value={d.country || ""} readOnly />
                </div>
                <div className="sep-input-group">
                  <label>PIN Code</label>
                  <input type="text" value={d.pincode || ""} readOnly />
                </div>
              </div>
            </div>

            {/* Bank Details */}
            <div className="sep-form-section">
              <div className="sep-section-title">
                <FaUser />
                <span>Bank Details</span>
              </div>
              <div className="sep-form-grid">
                <div className="sep-input-group">
                  <label>Bank Name</label>
                  <input type="text" value={d.bankName || ""} readOnly />
                </div>
                <div className="sep-input-group">
                  <label>Account Holder Name</label>
                  <input type="text" value={d.accountHolderName || ""} readOnly />
                </div>
                <div className="sep-input-group">
                  <label>Account Number</label>
                  <input type="text" value={d.bankAccountNumber || ""} readOnly />
                </div>
                <div className="sep-input-group">
                  <label>Branch</label>
                  <input type="text" value={d.branch || ""} readOnly />
                </div>
                <div className="sep-input-group">
                  <label>IFSC</label>
                  <input type="text" value={d.ifsc || ""} readOnly />
                </div>
                <div className="sep-input-group">
                  <label>UPI ID</label>
                  <input type="text" value={d.upiId || ""} readOnly />
                </div>
              </div>
            </div>

            {/* Assets */}
            <div className="sep-form-section">
              <div className="sep-section-title">
                <FaUser />
                <span>Assets</span>
              </div>
              <div className="sep-input-group">
                <label>Assets</label>
                <div
                  className="sep-assets-box"
                  onClick={() => assetInputRef.current?.focus()}
                >
                  {assets.map((asset, i) => (
                    <span key={i} className="sep-asset-tag">
                      {asset}
                      <button
                        className="sep-asset-remove"
                        onClick={(e) => {
                          e.stopPropagation();
                          handleRemoveAsset(i);
                        }}
                      >
                        ×
                      </button>
                    </span>
                  ))}
                  <input
                    ref={assetInputRef}
                    className="sep-asset-input"
                    value={assetInput}
                    onChange={(e) => setAssetInput(e.target.value)}
                    onKeyDown={handleAddAsset}
                    placeholder={assets.length === 0 ? "Type asset and press Enter..." : ""}
                  />
                </div>
              </div>
            </div>

            {/* Salary Details */}
            <div className="sep-form-section">
              <div className="sep-section-title">
                <FaUser />
                <span>Salary Details</span>
              </div>
              <div className="sep-form-grid" style={{ marginBottom: "16px" }}>
                <div className="sep-input-group">
                  <label>Job Role</label>
                  <input type="text" value={d.jobRole || ""} readOnly />
                </div>
                <div className="sep-input-group">
                  <label>Band</label>
                  <input type="text" value={d.band || ""} readOnly />
                </div>
              </div>

              {/* Components sub-table */}
              {salaryComponents.length > 0 && (
                <>
                  <p style={{ fontSize: "13px", fontWeight: 600, color: "#2ca4d9", marginBottom: "8px" }}>
                    Components
                  </p>
                  <table className="sep-components-table">
                    <thead>
                      <tr>
                        <th className="sep-comp-th">Component Name</th>
                        <th className="sep-comp-th">Component Type</th>
                        <th className="sep-comp-th">Amount</th>
                      </tr>
                    </thead>
                    <tbody>
                      {salaryComponents.map((comp, i) => (
                        <tr key={i}>
                          <td className="sep-comp-td">{comp.componentName || comp.name || "-"}</td>
                          <td className="sep-comp-td">{comp.componentType || comp.type || "-"}</td>
                          <td className="sep-comp-td">{comp.amount || "-"}</td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </>
              )}

              {salaryComponents.length === 0 && (
                <div
                  style={{
                    fontSize: "13px",
                    color: "#aaa",
                    padding: "12px",
                    border: "1px dashed #e0e0e0",
                    borderRadius: "8px",
                    textAlign: "center",
                  }}
                >
                  No salary components available
                </div>
              )}
            </div>

          </>
        )}
      </div>

      {/* Termination Popup */}
      {showTerminateModal && (
        <TerminationPopup
          employee={employee}
          assets={assets}
          onClose={() => setShowTerminateModal(false)}
          onSuccess={() => {
            setShowTerminateModal(false);
            onBack();
          }}
        />
      )}

      {/* Exit Popup */}
      {showExitModal && (
        <ExitPopup
          employee={employee}
          assets={assets}
          onClose={() => setShowExitModal(false)}
          onSuccess={() => {
            setShowExitModal(false);
            onBack();
          }}
        />
      )}
    </div>
  );
};

export default SeparationDetail;
